import React, { useState, useMemo, useRef, useEffect } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import 'ag-grid-enterprise';
import ConfirmDeleteModal from "../confirmdeletemodal";
import loaderGif from "../../../assets/loader.gif";
import api from '../../../config/axiosConfig'
import dayjs from 'dayjs';

const Items = () => {
    const [formData, setFormData] = useState({  // To store user input
        name: '',
        itemtypeid: '',
        categoryid: '',
        shortdesc: '',
        longdesc: '',
        ordernoticeperiod: '',
        attribute: '',
        attribute2: '',
        mingroupsize: '',
        maxgroupsize: '',
        note: '',
        minquantity: '',
        perpersonrateINR: '',
        perpersonrateUSD: '',
        pricev2:'',
        SGST: '',
        CGST: '',
        IGST: '',
        CESS: '',
        isactive: true, // Default to true
        rank: '',
        Filters: [],
        availability: []
    });
    const [isEditMode, setIsEditMode] = useState(false); // To track if we are in edit mode
    const [categories, setCategories] = useState();
    const [itemtypes, setItemTypes] = useState();
    const [filters, setFilters] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [selectedAvailability, setSelectedAvailability] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [loader, setLoader] = useState(false);
    const gridRef = useRef();

    const getData = async () => {
         try {
             const response = await api.get('/items')
             const itemtypes = await api.get('/itemtypes')
             const categories = await api.get('/categories')
             const foodfilters = await api.get('/filters')

             setItemTypes(itemtypes.data)
             setCategories(categories.data)
             setFilters(foodfilters.data);
            //  console.log(response)

         } catch (error) {
            console.log("error for fetching the data", error);
         }
    };
    useEffect(() => {
        getData();
    }, []);

    const columnDefs = [
        { headerName: 'ID', field: 'id', sort: "desc", filter: 'agNumberColumnFilter' },
        { headerName: 'Name', field: 'name', filter: 'agTextColumnFilter' },
        { headerName: 'Category', field: 'itemtypeid', filter: 'agNumberColumnFilter' },
        { headerName: 'Sub Category', field: 'categoryid', filter: 'agNumberColumnFilter' },
        { headerName: 'Rank', field: 'rank', filter: 'agNumberColumnFilter' },
        { headerName: 'Short Description', field: 'shortdesc', filter: 'agTextColumnFilter' },
        { headerName: 'Long Description', field: 'longdesc', filter: 'agTextColumnFilter' },
        { headerName: 'Order Notice Period', field: 'ordernoticeperiod', filter: 'agTextColumnFilter' },
        { headerName: 'Attribute', field: 'attribute', filter: 'agTextColumnFilter' },
        { headerName: 'Attribute2', field: 'attribute2', filter: 'agTextColumnFilter' },
        { headerName: 'Maximum Group Size', field: 'maxgroupsize', filter: 'agNumberColumnFilter' },
        { headerName: 'Minimum Group Size', field: 'mingroupsize', filter: 'agNumberColumnFilter' },
        { headerName: 'Note', field: 'note', filter: 'agTextColumnFilter', filter: 'agNumberColumnFilter' },
        { headerName: 'minquantity', field: 'minquantity', filter: 'agTextColumnFilter', filter: 'agNumberColumnFilter' },

        { headerName: 'Per Person Rate (INR)', field: 'perpersonrateINR', filter: 'agNumberColumnFilter' },
        { headerName: 'Per Person Rate (USD)', field: 'perpersonrateUSD', filter: 'agNumberColumnFilter' },
        { headerName: 'Price V2', field: 'pricev2', filter: 'agNumberColumnFilter' },
        { headerName: 'SGST', field: 'SGST', filter: 'agNumberColumnFilter' },
        { headerName: 'CGST', field: 'CGST', filter: 'agNumberColumnFilter' },
        { headerName: 'IGST', field: 'IGST', filter: 'agNumberColumnFilter' },
        { headerName: 'CESS', field: 'CESS', filter: 'agNumberColumnFilter' },
        { headerName: 'selected Filters', field: 'filters', filter: 'agTextColumnFilter'},
        { headerName: 'selected Availability', field: 'availability', filter: 'agTextColumnFilter'},
        { headerName: 'Is Active', field: 'isactive' },
        { headerName: 'Created At', field: 'createddate', filter: 'agDateColumnFilter' },
        { headerName: 'Updated At', field: 'modifieddate', filter: 'agDateColumnFilter' },
        {
            field: "actions",
            headerName: "Actions",
            cellRenderer: (params) => (
                <Button
                    variant="danger"
                    className="btn-sm"
                    onClick={() => handleDelete(params.data)}
                >
                    <i class="bi bi-trash3"></i>
                </Button>
            ),
        },
        // Add more columns as needed
    ];

    const sideBar = useMemo(() => {
        return {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                },
                {
                    id: 'filters',
                    labelDefault: 'Filters',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                }
            ],
            defaultToolPanel: '',
        };
    }, []);

    // Server-Side Datasource
    const datasource = {
        getRows: async function (params) {
            try {
                const { request } = params;
                
                const response = await api.post('/items/ag', { ...request });
                const { rows, lastRow } = response.data;

                // Send data back to AG Grid
                params.successCallback(rows, lastRow);
            } catch (error) {
                console.error("Error fetching rows:", error);
                params.failCallback();
            }
        }
    };

    const gridOptions = {
        rowModelType: 'serverSide',
        columnDefs: columnDefs,

        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: true,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true,
            filterParams: {
                buttons: ["reset"],
                closeOnApply: true,
            },
        },

        sideBar: sideBar,
        rowGroupPanelShow: 'always',
        rowSelection: 'single',
        columnHoverHighlight: true,
        suppressRowGroupHidesColumns: true,
        cacheBlockSize: 20,
    }

    // Attach the datasource when the grid is ready
    const onGridReady = (params) => {
        // console.log("params",params)[p]
        params.api.setServerSideDatasource(datasource);
    };

    const handleItemTypeChange = (e) => {
        const selectedItemTypeId = Number(e.target.value); // Get the selected item type ID
        setFormData({ ...formData, itemtypeid: selectedItemTypeId });

        // Filter categories based on the selected item type
        const filtered = categories.filter(category => category.itemTypeId == selectedItemTypeId);
        setFilteredCategories(filtered); // Set the filtered categories
        // console.log("Filtered categories:", filtered); 
    };

    const handleCheckboxChange = (filterId) => {
        setSelectedFilters((prevSelected) => {
            const updatedFilters = (prevSelected ?? []).includes(filterId)
                ? (prevSelected ?? []).filter((id) => id !== filterId) // Remove if already selected
                : [...(prevSelected ?? []), filterId]; // Add if not selected
            // Update formData with the correct filters array
            setFormData((prevData) => ({
                ...prevData,
                filters: Array.isArray(updatedFilters) ? JSON.stringify(updatedFilters) : "[]", // Ensure Filters is updated in formData
            }));
            // console.log("updatedFilters", updatedFilters)
            return updatedFilters;
        });
    };

    const handleAvailability = (availabilityId) => {
        setSelectedAvailability((prevSelected = []) => {
            const updatedAvailability = prevSelected.includes(availabilityId)
                ? prevSelected.filter((id) => id !== availabilityId) // Remove if already selected
                : [...prevSelected, availabilityId]; // Add if not selected
    
            setFormData((prevData) => ({
                ...prevData,
                availability: JSON.stringify(updatedAvailability), // Store as JSON string
            }));
    
            return updatedAvailability;
        });
    };
    
    
//   handleCheckboxChange()

    // Row selection handler
    const onRowSelected = (event) => {
        if (event.node.isSelected()) {
            const selectedData = event.data;
            // Ensure Filters is an array before using map

            
    
            setFormData({
                Filters: selectedData.filters, // Set the selected filters properly
                availability: selectedData.availability,
                id: selectedData.id,
                name: selectedData.name,
                itemtypeid: selectedData.itemtypeid,
                categoryid: selectedData.categoryid,
                shortdesc: selectedData.shortdesc,
                longdesc: selectedData.longdesc,
                ordernoticeperiod: selectedData.ordernoticeperiod,
                attribute: selectedData.attribute,
                attribute2: selectedData.attribute2,
                mingroupsize: selectedData.mingroupsize,
                maxgroupsize: selectedData.maxgroupsize,
                note: selectedData.note,
                minquantity: selectedData.minquantity,
                perpersonrateINR: selectedData.perpersonrateINR,
                perpersonrateUSD: selectedData.perpersonrateUSD,
                pricev2:selectedData.pricev2,
                SGST: selectedData.SGST,
                CGST: selectedData.CGST,
                IGST: selectedData.IGST,
                CESS: selectedData.CESS,
                isactive: selectedData.isactive,
                rank: selectedData.rank
            });
    
            setSelectedFilters(selectedData.filters);
            setSelectedAvailability(selectedData.availability);
            setIsEditMode(true);
        }
    };

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
    
        setFormData(prevState => {
            if (type === 'checkbox') {
                if (name === 'availability') {
                    // Ensure availability is always an array
                    const updatedAvailability = checked
                        ? Array.from(new Set([...(prevState.availability || []), value])) // Add without duplicates
                        : (prevState.availability || []).filter(item => item !== value); // Remove unchecked slot
    
                    return {
                        ...prevState,
                        availability: updatedAvailability
                    };
                }
                return {
                    ...prevState,
                    [name]: checked // Handle other checkbox inputs
                };
            } 
            
            return {
                ...prevState,
                [name]: type === 'checkbox' ? checked : value// Handle other input types (text, select, etc.)
            };
        });
    };
    
    

    // Handle form submission to save data to Firestore
    const handleAddData = async (e) => {
        e.preventDefault();
        if (formData.name) {
            try {
                const url = isEditMode ? `/items/${formData.id}` : '/items';
                const method = isEditMode ? 'put' : 'post';
                // Make the Axios call using the api instance
                await api({
                    method,
                    url,
                    data: {
                    name: formData.name || null,
                    itemtypeid: formData.itemtypeid || null,
                    categoryid: formData.categoryid || null,
                    shortdesc: formData.shortdesc || null,
                    longdesc: formData.longdesc || null,
                    attribute: formData.attribute || null,
                    attribute2: formData.attribute2 || null,
                    note: formData.note || null,
                    minquantity: formData.minquantity || null,
                    mingroupsize: formData.mingroupsize || null,
                    maxgroupsize: formData.maxgroupsize || null,
                    ordernoticeperiod: formData.ordernoticeperiod || null,
                    perpersonrateINR: formData.perpersonrateINR || null,
                    perpersonrateUSD: formData.perpersonrateUSD || null,
                    pricev2: formData.pricev2 || null,
                    CESS: formData.CESS || null,
                    CGST: formData.CGST || null,
                    IGST: formData.IGST || null,
                    SGST: formData.SGST || null,
                        filters: selectedFilters || [],
                        availability: selectedAvailability || [],
                    isactive: formData.isactive || false, // Default to false if empty
                    itemRank: formData.rank || null
                }
                //    console.log("data is ", data);
              })
 
          } catch (error) {
            console.error('Error:', error);
          }
            // Clear the form
            setFormData({ id: null, name: '', itemtypeid: '', categoryid:'', shortdesc:'', longdesc:'', attribute:'', attribute2:'', note:'', minquantity:'', mingroupsize:'', maxgroupsize:'', ordernoticeperiod:'', perpersonrateINR:'', perpersonrateUSD:'', pricev2:'', CESS:'', CGST: '', IGST:'', SGST:'', selectedFilters: [], selectedAvailability: [], isactive: true, rank: '' });
            setIsEditMode(false); // Reset to add mode
            gridRef.current.api.refreshServerSideStore({ purge: true });
        } else {
            alert("Please fill out the name field.");
        }
    };

    // Reset form for new entry
    const handleNewEntry = () => {
        setFormData({ id: null, name: '', itemtypeid: '', categoryid: '', shortdesc: '', longdesc: '', attribute: '', attribute2: '', note: '', minquantity:'',  mingroupsize: '', maxgroupsize: '', ordernoticeperiod: '', perpersonrateINR: '', perpersonrateUSD: '', pricev2:'',  CESS:'', CGST: '', IGST:'', SGST:'', selectedFilters: [], selectedAvailability: [], isactive: true, rank: '' });
        setIsEditMode(false);  // Switch to add mode
    };

    const handleDelete = (category) => {
        setSelectedRow(category); // Store the category to be deleted
        setShowModal(true); // Show the modal
    };

    const confirmDelete = async () => {
        if (selectedRow) {
            try {
                await api.delete(`/items/${selectedRow.id}`);
                setShowModal(false);
                gridRef.current.api.refreshServerSideStore({ purge: true });
            } catch (error) {
                console.error('Error deleting item:', error);
            }
        }
    };

    return (
        <>
            <Container fluid>
                {/* Category List */}
                <Row className="mt-4">
                    <h6 className="text-start">Item List</h6>
                    <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            ref={gridRef}
                            gridOptions={gridOptions}
                            onGridReady={onGridReady}
                            onRowSelected={onRowSelected}
                        />
                    </div>
                </Row>
                <Row className="mt-4 border shadow p-4">
                    {loader && (
                        <div className="loader-overlay">
                            <img src={loaderGif} alt="Loading..." className="loader" />
                        </div>
                    )}
                    <h6 className="text-start">Add Item</h6>
                    <Form onSubmit={handleAddData}>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="me-3">Name:</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="Enter category name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        name="isactive"
                                        label="Is Active"
                                        checked={formData.isactive}
                                        onChange={handleChange}
                                        className="ms-4"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Item Types</Form.Label>
                                    <InputGroup>
                                        <Form.Select
                                            name="itemtypeid"
                                            value={formData.itemtypeid}  // This will hold the selected item type ID
                                            onChange={handleItemTypeChange} // Handle item type change
                                        >
                                            <option value="">Select Item Type</option>
                                            {itemtypes && itemtypes.map((itemtype) => (
                                                <option key={itemtype.id} value={itemtype.id}>
                                                    {itemtype.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Category</Form.Label>
                                    <InputGroup>
                                        <Form.Select
                                            name="categoryid"
                                            value={formData.categoryid}  // This will hold the selected category ID
                                            onChange={(e) => setFormData({ ...formData, categoryid: Number(e.target.value) })} // Store as number
                                        >
                                            <option value="">Select a category</option>
                                            {filteredCategories && filteredCategories.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Short Description<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="shortdesc"
                                            placeholder="Enter Short Description"
                                            value={formData.shortdesc}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Long Description</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            as="textarea"
                                            name="longdesc"
                                            placeholder="Enter Long Description"
                                            value={formData.longdesc}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Order Notice Period <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="ordernoticeperiod"
                                            placeholder="Enter Order Notice Period"
                                            value={formData.ordernoticeperiod}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Attribute</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="attribute"
                                            placeholder="Enter Attribute"
                                            value={formData.attribute}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Attribute2</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="attribute2"
                                            placeholder="Enter Attribute2"
                                            value={formData.attribute2}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Minimum Group Size <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="mingroupsize"
                                            placeholder="Enter Minimum Group Size"
                                            value={formData.mingroupsize}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Maximum Group Size</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="maxgroupsize"
                                            placeholder="Enter Maximum Group Size"
                                            value={formData.maxgroupsize}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Note <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            as="textarea"
                                            name="note"
                                            placeholder="Enter Notes"
                                            value={formData.note}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            
                        </Row>
                        <Row className="mt-3">
                        <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Minimum Quantity <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="minquantity"
                                            placeholder="Enter Minimum Quantity For Food"
                                            value={formData.minquantity}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>

                            <Col>
                            <Form.Group>
                                    <Form.Label>Per Person Rate (INR)<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="perpersonrateINR"
                                            placeholder="Enter Per Person Rate (INR)"
                                            value={formData.perpersonrateINR}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            </Row>

                         <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Per Person Rate (USD)</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="perpersonrateUSD"
                                            placeholder="Enter Per Person Rate (USD)"
                                            value={formData.perpersonrateUSD}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Price V2</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="pricev2"
                                            placeholder="Enter Price V2"
                                            value={formData.pricev2}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            </Row>
                             <Row  className="mt-3">
                           
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>SGST <span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="SGST"
                                            placeholder="Enter SGST"
                                            value={formData.SGST}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>CGST</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="CGST"
                                            placeholder="Enter CGST"
                                            value={formData.CGST}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>IGST<span style={{ color: 'red' }}></span></Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="IGST"
                                            placeholder="Enter IGST"
                                            value={formData.IGST}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>CESS</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            name="CESS"
                                            placeholder="Enter CESS"
                                            value={formData.CESS}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Rank</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="rank"
                                            placeholder="Enter Rank"
                                            value={formData.rank}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>   
                        <Row className="mt-3">
                            <Col md={6}>
                            <Form.Group>
                                <Form.Label>Select Filters</Form.Label>
                                <div className="checkbox-group">
                                    {filters && filters.map((filter) => (
                                        <div key={filter.id} className="checkbox-container">
                                          <input
                                                type="checkbox"
                                                id={`filter-${filter.id}`}
                                                value={filter.id}
                                                checked={(selectedFilters ?? []).includes(filter.id)} // Ensure selectedFilters is always an array
                                                onChange={() => handleCheckboxChange(filter.id)}
                                            />
                                            <label htmlFor={`filter-${filter.id}`}>{filter.name}</label>
                                        </div>
                                    ))}
                                </div>
                            </Form.Group>
                            </Col>      
                            <Col md={6}>
                            <Form.Group>
                                    <Form.Label>Select Availability</Form.Label>
                                    <div className="checkbox-group">
                                        {[
                                            { id: 1, name: "7 AM to 10 AM" },
                                            { id: 2, name: "12 PM to 2 PM" },
                                            { id: 3, name: "4 PM to 6 PM" },
                                            { id: 4, name: "8 PM to 10 PM" },
                                        ].map((availability) => (
                                            <div key={availability.id} className="checkbox-container">
                                                <input
                                                    type="checkbox"
                                                    id={`availability-${availability.name}`}
                                                    value={availability.name}
                                                    checked={selectedAvailability.includes(availability.name)} // ✅ Corrected logic
                                                    onChange={() => handleAvailability(availability.name)}
                                                />
                                                <label htmlFor={`availability-${availability.name}`}>{availability.name}</label>
                                        </div>
                                    ))}
                                </div>
                            </Form.Group>
                            </Col>                     
                        </Row>
                        <Button variant="primary" type="submit" className="mt-4">
                            {isEditMode ? "Update" : "Add"}
                        </Button>
                        {isEditMode ?
                            <Button variant="secondary" className="ms-3 mt-4" onClick={handleNewEntry}>
                                Create New Entry
                            </Button>
                            : ''
                        }
                    </Form>
                </Row>
            </Container>

            {/* Modal for confirming deletion */}
            <ConfirmDeleteModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={confirmDelete}
                title="Confirm Deletion"
                body={`Are you sure you want to delete ${selectedRow?.name}?`}
                confirmText="Delete"
            />


        </>
    );
};

export default Items


